<template>
  <page-outline :title="changePassword_title">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <b-row class="ml-5 mb-4 mr-5 mr-5 form-group font-weight-bold">
          <b-col sm="5">
            <form-read-group-label-input
              :inputLabel="$t('common.idtfr')" :inputValue="login">
            </form-read-group-label-input>
          </b-col>
          <!-- <b-col v-if="!connectToGoogle" sm="5">
            <form-write-group-label-input v-model="originalPassword" isMandatory
              :inputLabel="$t('common.orig_pwd')"
              inputType="password">
            </form-write-group-label-input>
          </b-col> -->
          <b-col v-if="!connectToGoogle" sm="5" class="form-group">
            <label>{{$t('common.orig_pwd')}}<span style="color: red"> *</span></label>
            <div class="d-flex">
              <input v-model="originalPassword"
                class="form-control inputAccordionForm h-30px"
                :type="currentPasswordType"
                :placeholder="$t('common.orig_pwd')">
                <div class="icon icon-password mt-2 pt-1 icon-field"
                  :class="[isCurrentPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                  @click="switchCurrentPasswordType">
                </div>
              </input>
            </div>
          </b-col>
        </b-row>
        <b-row class="ml-5 mb-4 mr-5 mr-5 form-group font-weight-bold">
          <!-- <b-col v-if="!connectToGoogle" sm="5">
            <form-write-group-label-input v-model="newPassword" isMandatory
              :inputLabel="$t('common.new_pwd')"
              inputType="password">
            </form-write-group-label-input>
          </b-col> -->
          <b-col v-if="!connectToGoogle" sm="5" class="form-group">
            <label>{{$t('common.new_pwd')}}<span style="color: red"> *</span></label>
            <div class="d-flex">
              <input v-model="newPassword"
                class="form-control inputAccordionForm h-30px"
                :type="newPasswordType"
                :placeholder="$t('common.new_pwd')">
                <div class="icon icon-password mt-2 pt-1 icon-field"
                  :class="[isNewPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                  @click="switchNewPasswordType">
                </div>
              </input>
            </div>
          </b-col>
          <!-- <b-col sm="5">
            <form-write-group-label-input v-model="confirmNewPassword" isMandatory
              :inputLabel="$t('common.conf_pwd')"
              inputType="password">
            </form-write-group-label-input>
          </b-col> -->
          <b-col sm="5" class="form-group">
            <label>{{$t('common.conf_pwd')}}<span style="color: red"> *</span></label>
            <div class="d-flex">
              <input v-model="confirmNewPassword"
                class="form-control inputAccordionForm h-30px"
                :type="confirmNewPasswordType"
                :placeholder="$t('common.conf_pwd')">
                <div class="icon icon-password mt-2 pt-1 icon-field"
                  :class="[isConfirmNewPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                  @click="switchConfirmNewPasswordType">
                </div>
              </input>
            </div>
          </b-col>
        </b-row>
        <b-row class="form-group justify-content-end mr-5">
          <b-col lg="2">
            <b-button
              :title="changePassword_Validatechanges"
              variant="primary"
              @click="changePassword">
              <i class="fa-light fa-floppy-disk"></i>
              <span>{{ $t('common.sve') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import backButton from "@/components/common/backButton.vue"
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'back-button': backButton,
    'bottom-toolbar': bottomToolbar,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  computed: {
    isCurrentPasswordFieldHidden () {
      return this.currentPasswordType === 'password'
    },
    isConfirmNewPasswordFieldHidden () {
      return this.confirmNewPasswordType === 'password'
    },
    isNewPasswordFieldHidden () {
      return this.newPasswordType === 'password'
    }
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      isSmartphone: false,
      login: '',
      originalPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      connectToGoogle: false,
      confirmNewPasswordType: 'password',
      currentPasswordType: 'password',
      newPasswordType: 'password',
      returnUrl: '/profile/'
    }
  },
  created () {
    this.changePassword_title = this.$i18n.t('common.chg_pwd')
    this.changePassword_Validatechanges = this.$i18n.t('common.valid_chgs')
    /* if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    } */
    /* this.login = this.$engine.user.get().identifier */
    this.getUserAccountInfo()
  },
  mounted () {
    this.connectToGoogle = false
  },
  methods: {
    changePasswordAPI (connectBy) {
      let that = this
      this.$engine.user.changePassword({
        originalPassword: this.originalPassword,
        newPassword: this.newPassword,
        'connectBy': connectBy
      })
      .then(response => {
        if (response.status === 200) {
          this.$engine.user.connectBy = 'login-password-capi'
          that.$f7.modal({
            title: this.$t('common.security.password_modified'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/profile/', force: false, ignoreCache: false})
          }, 2000)
        }
      })
      .catch(error => {
        if (error.response.data.error === 'oldPassword not valid') {
          that.$f7.modal({
          title: that.$t('profilesPage.password_old_not_valid'),
          text: that.$t('profilesPage.password_old_not_match'),
          buttons: [
            {
              text: this.$t('common.cncl'),
              onClick: function () {
                return
              }
            }
          ]
        })
      } else if (error.response.data.error === 'newPasswordAlreadyUsed') {
          that.$f7.modal({
          title: that.$t('profilesPage.new_password_used'),
          text: that.$t('profilesPage.new_password_used_7_pwd'),
          buttons: [
            {
              text: this.$t('common.cncl'),
              onClick: function () {
                return
              }
            }
          ]
        })
      } else {
          errorMessageAlert(error, that)
        }
      })
    },
    changePassword () {
      let that = this
      let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      if (that.originalPassword === '' && this.$engine.user.connectBy !== 'vue-google-oauth2') {
        that.$f7.alert(that.$i18n.t('profilesPage.password_original_missing'), that.$i18n.t('common.error_title'))
      } else if (that.newPassword === '') {
        that.$f7.alert(that.$i18n.t('errors.new_pwd_mssng'), that.$i18n.t('common.error_title'))
      } else if (that.confirmNewPassword === '') {
        that.$f7.alert(that.$i18n.t('errors.cnfrm_pwd'), that.$i18n.t('common.error_title'))
      } else if (!regexPassword.test(that.newPassword)) {
        that.$f7.alert(that.$i18n.t('profilesPage.password_wrong_format'), that.$i18n.t('common.error_title'))
      } else if (that.newPassword !== that.confirmNewPassword) {
        that.$f7.alert(that.$i18n.t('common.security.passwords_not_matching'), that.$i18n.t('common.error_title'))
      } else if (that.originalPassword === that.newPassword) {
        that.$f7.alert(that.$i18n.t('common.security.password_same'), that.$i18n.t('common.error_title'))
      } else {
        var connectBy = 'lpc'
        if (this.$engine.user.connectBy === 'vue-google-oauth2') {
          connectBy = 'vgo'
          // On se conecte via Google
          this.$gAuth.signIn()
          .then(GoogleUser => {
            that.changePasswordAPI(connectBy)
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
        } else {
          this.changePasswordAPI(connectBy)
        }
      }
    },
    getUserAccountInfo () {
      let info = this.$engine.accounts.get()
      let userAccounts
      let userAccountId

      userAccounts = info[0].userAccts
      userAccountId = info[0].userAccountId
      userAccounts = userAccounts.filter((account) => account.id === userAccountId)
      this.updateUserAccountInfo(userAccounts)
    },
    switchConfirmNewPasswordType () {
      if (this.confirmNewPasswordType === 'password') {
        this.confirmNewPasswordType = 'text'
      } else {
        this.confirmNewPasswordType = 'password'
      }
    },
    switchCurrentPasswordType () {
      if (this.currentPasswordType === 'password') {
        this.currentPasswordType = 'text'
      } else {
        this.currentPasswordType = 'password'
      }
    },
    switchNewPasswordType () {
      if (this.newPasswordType === 'password') {
        this.newPasswordType = 'text'
      } else {
        this.newPasswordType = 'password'
      }
    },
    updateUserAccountInfo (userAccount) {
      let userAccountInfo = userAccount
      this.login = userAccountInfo[0].login
      /* this.userName = userAccountInfo[0].name
      this.userProfile = userAccountInfo[0].profile */
    }
  }
}
</script>
<style scoped>
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}
</style>
